import React, { Component } from "react";

import { Validate } from "common";
import { Page, Breadcrumbs, Panel, Form, Loading } from "components";
import CPF from "gerador-validador-cpf";
import swal from "sweetalert";
import moment from "moment";

import * as XLSX from "xlsx";

import api from "services/api";
import { ERelationshipStatus, ERelationshipStatusPtBR } from "enums";

class ExtractionInhabitant extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Extração", to: "/extraction" },
      { name: "Extração - Dados CPF", to: "" },
    ],
    errors: {},
    document: "",
    loading: false,
  };

  handleValidate = () => {
    const { document } = this.state;

    const rules = {
      document: {
        required: true,
        cpf: true,
      },
    };

    const validate = Validate({ document }, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleExport = async () => {
    if (!this.handleValidate()) return null;
    const { document } = this.state;

    try {
      this.setState({ loading: true });

      const { data } = await api.get(
        `user/v2/inhabitant_data/${CPF.format(document, "digits")}`,
        {
          accept: "application/json",
        }
      );

      // create workbook
      const workbook = XLSX.utils.book_new();

      // create sheets
      const personal = XLSX.utils.json_to_sheet([], {
        header: [
          "Nome",
          "CPF",
          "Email",
          "Status",
          "Plano",
          "Segmento",
          "Data de Aniversário",
          "Loja Favorita",
          "Pontuação Atual",
          "Data de Registro",
        ],
      });
      const plans = XLSX.utils.json_to_sheet([], {
        header: ["Plano", "Entrada", "Saída"],
      });
      const expiredPoints = XLSX.utils.json_to_sheet([], {
        header: ["Ano", "Total"],
      });
      const documents = XLSX.utils.json_to_sheet([], {
        header: ["Tipo de Documento", "Número"],
      });
      const customers = XLSX.utils.json_to_sheet([], {
        header: [
          "Nome",
          "Projeto",
          "Status do Convite",
          "Data Início",
          "Data Fim",
        ],
      });
      const vouchers = XLSX.utils.json_to_sheet([], {
        header: ["", "", "", "", "External"],
      });
      vouchers["!merges"] = [{ s: { r: 0, c: 4 }, e: { r: 0, c: 9 } }];
      const benefits = XLSX.utils.json_to_sheet([], {
        header: ["", "", "", "", "", "External"],
      });
      benefits["!merges"] = [{ s: { r: 0, c: 5 }, e: { r: 0, c: 11 } }];
      const checkouts = XLSX.utils.json_to_sheet([], {
        header: ["Data", "Valor da Compra", "Valor Pontos Gerados"],
      });

      // personal
      XLSX.utils.sheet_add_json(personal, [data.personal], {
        skipHeader: true,
        origin: "A2",
      });

      // plans
      XLSX.utils.sheet_add_json(
        plans,
        data.plans.map((plan) => [plan.name, plan.start_date, plan.end_date]),
        { skipHeader: true, origin: "A2" }
      );

      // expired points
      XLSX.utils.sheet_add_json(expiredPoints, data.expired_points, {
        skipHeader: true,
        origin: "A2",
      });

      // documents
      XLSX.utils.sheet_add_json(
        documents,
        data.documents.map((document) => [document.type, document.number]),
        { skipHeader: true, origin: "A2" }
      );

      // customers
      XLSX.utils.sheet_add_json(
        customers,
        this.parseCustomers(data.customers),
        {
          skipHeader: true,
          origin: "A2",
        }
      );

      // vouchers
      XLSX.utils.sheet_add_aoa(
        vouchers,
        [
          [
            "Data de Ativação",
            "Valor",
            "Data de Expiração",
            "Utilizado (Sim/Não)",
            "ID Voucher",
            "Loja",
            "Data",
            "PDV",
            "Cupom",
            "Cupom Ecommerce",
          ],
        ],
        { skipHeader: true, origin: "A2" }
      );
      XLSX.utils.sheet_add_json(
        vouchers,
        data.vouchers.map((voucher) => [
          voucher.activation,
          voucher.discount,
          voucher.expiration,
          voucher.used ? "Sim" : "Não",
          voucher.voucher_id,
          voucher.store,
          voucher.date,
          voucher.pdv,
          voucher.ticket,
          voucher.ecommerce_ticket,
        ]),
        { skipHeader: true, origin: "A3" }
      );

      // benefits
      XLSX.utils.sheet_add_aoa(
        benefits,
        [
          [
            "Data de Ativação",
            "Descrição",
            "Desconto %",
            "Data de expiração",
            "Utilizado (Sim/Não)",
            "ID Voucher",
            "Loja",
            "Data",
            "PDV",
            "Cupom",
            "Cupom Ecommerce",
          ],
        ],
        { skipHeader: true, origin: "A2" }
      );
      XLSX.utils.sheet_add_json(
        benefits,
        data.benefits.map((benefit) => [
          benefit.activation,
          benefit.description,
          benefit.discount,
          benefit.expiration,
          benefit.used ? "Sim" : "Não",
          benefit.voucher_id,
          benefit.store,
          benefit.date,
          benefit.pdv,
          benefit.ticket,
          benefit.ecommerce_ticket,
        ]),
        { skipHeader: true, origin: "A3" }
      );

      // checkouts
      XLSX.utils.sheet_add_json(checkouts, data.checkouts, {
        skipHeader: true,
        origin: "A2",
      });

      // add sheets to workbook
      XLSX.utils.book_append_sheet(workbook, personal, "Principal");
      XLSX.utils.book_append_sheet(workbook, plans, "Planos");
      XLSX.utils.book_append_sheet(
        workbook,
        expiredPoints,
        "Pontuação Expirada"
      );
      XLSX.utils.book_append_sheet(workbook, documents, "Documentos");
      XLSX.utils.book_append_sheet(workbook, customers, "Clientes");
      XLSX.utils.book_append_sheet(workbook, vouchers, "Vouchers");
      XLSX.utils.book_append_sheet(workbook, benefits, "Benefícios");
      XLSX.utils.book_append_sheet(workbook, checkouts, "Compras");

      XLSX.writeFile(workbook, `extracao-dados-cpf-${document}.xlsx`, {
        WTF: false,
        bookType: "xlsx",
      });
    } catch (err) {
      swal(
        "Ops, algo deu errado",
        "Não foi possível exportar os dados do habitante",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  /**
   * @typedef {Object} Customer
   * @property {string} client_name Example: "Fulano de Tal")
   * @property {string} project_name Example: "Reforma da casa"
   * @property {string} relationship_status Example: "accepted"
   * @property {string} start_date Example: "2025-02-12"
   * @property {string} end_date Example: "2025-03-14
   *
   * @param {Customer[]} customers
   * @returns The same object, but with its `relationship_status` field translated to pt-BR
   */
  parseCustomers(customers) {
    return customers.map((customer) => {
      let end_date = customer.end_date;

      if (customer.relationship_status === ERelationshipStatus.ACCEPTED) {
        const startDate = moment(customer.start_date, 'YYYY-MM-DD');

        const expirationDays = Number(customer.duration_days ?? 0);

        end_date = startDate.clone().add(expirationDays, 'days').format('YYYY-MM-DD');
      }

      return {
        ...customer,
        end_date,
        relationship_status:
          ERelationshipStatusPtBR[customer.relationship_status] ??
          customer.relationship_status,
      };
    });
  }


  render() {
    const { breadcrumbs, document, errors, loading } = this.state;

    return (
      <Page className="page-exportation">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-exportation-header">
          <Page.Title>Extração - Dados CPF</Page.Title>
        </header>

        <Panel className="panel-list">
          <div className="exporation-form">
            <Form.Input
              placeholder="CPF"
              mask="cpf"
              value={document}
              onChange={(document) => this.setState({ document })}
              errors={errors.document}
            />
            <button
              type="button"
              disabled={loading}
              onClick={() => this.handleExport()}
            >
              {loading ? (
                <Loading type="btn" size="small" text="Preparando ..." />
              ) : (
                "Exportar dados"
              )}
            </button>
          </div>
        </Panel>
      </Page>
    );
  }
}

export default ExtractionInhabitant;
